
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: () => { return {} } }) private node!: any
  private isDisableSubmit: boolean = false
  private showAddBtn: boolean = true
  private addTagValue: string = ''
  private nodeData: any = {}
  private formData = {
    id: 0,
    name: '',
    value: null,
    is_enable: true
  }
  private rules = {
    value: [
      { required: true }
    ],
    is_enable: [
      { required: true }
    ]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.globalConfigDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      this.nodeData = JSON.parse(JSON.stringify(Object.assign({}, this.node)))
      const data = {
        id: this.nodeData.id,
        name: this.nodeData.name,
        value: this.nodeData.value,
        is_enable: this.nodeData.is_enable
      }
      this.formData = Object.assign({}, data)
    }
  }

  validateNumber(rule: any, value: any, callback: any) {
    if (!Number.isInteger(Number(value))) {
      callback(new Error('请输入正整数'))
    } else if (Number(value) < 1) {
      callback(new Error('请输入大于 1 的正整数'))
    } else {
      callback()
    }
  }

  private handleAddTag() {
    const newTag = this.addTagValue
    if (newTag) {
      (this.formData.value as any).push(newTag)
    }
    this.showAddBtn = true
    this.addTagValue = ''
  }

  private handleCloseTag(tag: string) {
    (this.formData.value as any).splice((this.formData.value as any).indexOf(tag), 1)
    console.log(this.node)
  }

  private changeAddBtn() {
    this.showAddBtn = false
    this.$nextTick(() => {
      (this.$refs as any).addInput.focus()
    })
  }

  // 提交按钮触发
  private handleSubmit(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        return new Promise((resolve, reject) => {
          this.isDisableSubmit = true
          if (this.formData.name === '不满意评价通知') {
            (this.formData.value as any).forEach((item: any) => {
              if (!item.startsWith('W')) {
                this.isDisableSubmit = false
                this.$message({ message: '请输入完整工号信息!', type: 'error' })
                reject()
              }
            })
          } else if (this.formData.name.indexOf('提醒') !== -1) {
            if (!/^[1-9]+[0-9]*]*$/.test(this.formData.value as any)) {
              this.isDisableSubmit = false
              this.$message({ message: '只能输入正整数!', type: 'error' })
              reject()
            }
          } else if (this.formData.name === '统计时效') {
            const { startTime, endTime } = this.formData.value as any
            if (!startTime || !endTime) {
              this.isDisableSubmit = false
              this.$message({ message: '开始时间和结束时间不能为空!', type: 'error' })
              reject()
            }else if (startTime >= endTime) {
              this.isDisableSubmit = false
              this.$message({ message: '开始时间需早于结束时间!', type: 'error' })
              reject()
            }
          }
          resolve()
        }).then(_ => {
          this.editRequest()
        })
      }
    })
  }

  // 编辑保存
  private editRequest() {
    const value: any = this.formData.value
    CONFIGAPI.updateGlobalConfig({
      name: this.formData.name,
      is_enable: this.formData.is_enable,
      value: typeof value === 'object' ? JSON.stringify(value) : value
    }, {
      app_id: this.userCurrentApp
    }, this.formData.id).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'globalConfigDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'globalConfigDialog',
      value: false
    })
  }
}
